/**
 * [initSearch 搜索]
 * @param  {[String]} _keyword [关键词]
 */
function initSearch(_keyword) {
    var keyword = $('.search-form .keyword');
    var preValue = _keyword;

    function setStyle(isEmp) {
        keyword.css('color', isEmp ? '#999' : '#333');
    }
    keyword.val(_keyword);
    setStyle(true);
    keyword.focus(function() {
        if (preValue == keyword.val()) {
            keyword.val('');
            setStyle(false);
        }
    });
    keyword.blur(function() {
        if (keyword.val() == '') {
            keyword.val(preValue);
            setStyle(true);
        }
    });
}

/**
 * 与首页搜索框关键词内容保持同步
 */

$.ajax({
    url: '//interface.17173.com/inc/getContent.jsonp',
    dataType: 'jsonp',
    data: {
        url: 'http://www.17173.com/2016v2/inc/inc-search.shtml'
    }
}).done(function(data) {
    var keyword = $(data).find('input[name=keyword]').val();
    initSearch(keyword);
});


//////////////////
// WEBPACK FOOTER
// ./src/component/search.js
// module id = 6
// module chunks = 0